'use client';

import { Suspense } from 'react';
import { Button } from '../../../../../Clickables/Buttons/Button';
import { objectToQueryString, queryStringToObject } from '../../../../../../helpers/url/queryUtils';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { IInternalLinkProps } from '../../../../../Clickables/InternalLink/InternalLink';
import { useAnalytics } from '../../../../../../contexts/AnalyticsContext/AnalyticsContext';
import { trackEvent } from '../../../../../../helpers/analytics/trackEvent';

const SuspendedCreatePostButton = ({
  onClick,
  buttonSize,
  className,
}: {
  onClick: () => void;
  buttonSize: IInternalLinkProps['size'];
  className?: string;
}) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { replace } = useRouter();

  const openCreatePostModal = (): void => {
    const search = queryStringToObject(searchParams?.toString());
    const url = `${pathname}?${objectToQueryString({ ...search, add_post: 'show' })}`;
    replace(url);
    onClick();
  };

  return (
    <Button
      size={buttonSize}
      variant="buttonPrimary"
      className={className}
      onClick={() => {
        openCreatePostModal();
      }}
    >
      Add post
    </Button>
  );
};

export const CreatePostButton = ({
  buttonSize = 'default',
  className,
  onClick,
}: {
  buttonSize?: IInternalLinkProps['size'];
  className?: string;
  onClick?: () => void;
}) => {
  const { currentPage } = useAnalytics();
  return (
    <Suspense>
      <SuspendedCreatePostButton
        buttonSize={buttonSize}
        className={className}
        onClick={() => {
          void trackEvent({
            name: 'mykiss_hamburger_clicked',
            properties: { action: 'navigate', source: currentPage },
          });
          if (onClick) {
            onClick();
          }
        }}
      />
    </Suspense>
  );
};
